export const KEYWORD_SUGGESTION_INDEX_SUFFIX = 'query_suggestions';
export const REFINEMENT_LIMIT = 40;
